<template>
  <div>
    <v-main>
        <!-- <v-container style="padding: 0 0;"> -->
           <v-row style="padding: 20px 20px;">
            <v-col>
                <v-card
    outlined
    style="border-bottom-color:  blue;"
  >
    <v-list-item>
      <v-list-item-content>
        <v-col style="background-color: aqua;">1</v-col>
        <v-col style="background-color: blueviolet;">2</v-col>
      </v-list-item-content>
    </v-list-item>
  </v-card>
            </v-col>
            <v-col>
                <v-card
    outlined
  >
    <v-list-item three-line>
      <v-list-item-content>
        <div class="text-overline mb-4">
          OVERLINE
        </div>
        <v-list-item-title class="text-h5 mb-1">
          Headline 5
        </v-list-item-title>
        <v-list-item-subtitle>Greyhound divisely hello coldly fonwderfully</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-avatar
        tile
        size="80"
        color="grey"
      ></v-list-item-avatar>
    </v-list-item>

    <v-card-actions>
      <v-btn
        outlined
        rounded
        text
      >
        Button
      </v-btn>
    </v-card-actions>
  </v-card>
            </v-col>
            <v-col>
                <v-card
    outlined
  >
    <v-list-item three-line>
      <v-list-item-content>
        <div class="text-overline mb-4">
          OVERLINE
        </div>
        <v-list-item-title class="text-h5 mb-1">
          Headline 5
        </v-list-item-title>
        <v-list-item-subtitle>Greyhound divisely hello coldly fonwderfully</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-avatar
        tile
        size="80"
        color="grey"
      ></v-list-item-avatar>
    </v-list-item>

    <v-card-actions>
      <v-btn
        outlined
        rounded
        text
      >
        Button
      </v-btn>
    </v-card-actions>
  </v-card>
            </v-col>
            <v-col>
                <v-card
    outlined
  >
    <v-list-item three-line>
      <v-list-item-content>
        <div class="text-overline mb-4">
          OVERLINE
        </div>
        <v-list-item-title class="text-h5 mb-1">
          Headline 5
        </v-list-item-title>
        <v-list-item-subtitle>Greyhound divisely hello coldly fonwderfully</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-avatar
        tile
        size="80"
        color="grey"
      ></v-list-item-avatar>
    </v-list-item>

    <v-card-actions>
      <v-btn
        outlined
        rounded
        text
      >
        Button
      </v-btn>
    </v-card-actions>
  </v-card>
            </v-col>

           </v-row>
        <!-- </v-container> -->
    </v-main>

  </div>
</template>
<script>
// import axios from 'axios' // api
export default {
  name: 'home',
  components: {
  },
  data () {
    return {

    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  created () {

  },
  async mounted () {

  },
  methods: {

  }
}
</script>
<style scope>

</style>



// WEBPACK FOOTER //
// src/components/Core/Home.vue